import type { Store } from "redux";
import { IRootState } from "@utils";

export const getStore = (): Store => require("@components/Provider/store").store;
export const getStoreState = (): IRootState => getStore().getState();
